"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PercentPgHandler", {
    enumerable: true,
    get: function() {
        return PercentPgHandler;
    }
});
const _decimalpghandler = require("~/db/field-handler/handlers/decimal/decimal.pg.handler");
let PercentPgHandler = class PercentPgHandler extends _decimalpghandler.DecimalPgHandler {
};
